<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-logo">
        <img src="../assets/logo.svg" alt="SYAI Logo">
      </div>
      <div class="footer-divider"></div>
      <div class="footer-text">
        <p>© 2025 SY AI | All Rights Reserved</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  background-color: #3c93c6;
  padding: 2rem 0;
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-logo img {
  height: 40px;
  width: auto;
  margin-bottom: 1rem;
}

.footer-divider {
  width: 100%;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.3);
  margin: 1rem 0;
}

.footer-text {
  color: #ffffff;
  font-size: 0.9rem;
  text-align: center;
}

.footer-text p {
  margin: 0;
}

@media (max-width: 768px) {
  .footer-text {
    font-size: 0.8rem;
  }
}
</style>
